/*
 * The texts of the workflow extension, merged into the lib's own through its js/extension.ts.
 */
export default {
	sidebar: {
		workflows: 'Abläufe',
	},
	pages: {
		workflows: {
			title: 'Abläufe',
			info: 'Ein Ablauf ist entweder eine Kette - vorwärts, mit Ausgängen - oder ein freies Board. Die Reihenfolge steht im Katalog, eine Variante lässt Schritte weg. Abgeschaltete Schritte bleiben als Lücke sichtbar.',
			none: 'Diese Anwendung hat keine konfigurierbaren Abläufe.',
			required: 'Pflichtschritt',
			phase: 'Phase ohne Abschluss',
			field_visible: 'Wird abgefragt',
			field_required: 'Pflicht',
			exits_hint: 'Die Ausgänge ({steps}) gehören zu jeder Kette und lassen sich nicht abschalten.',
			free_hint: 'Ein freier Ablauf kennt keine Reihenfolge: jeder Zustand ist von jedem aus erreichbar.',
		},
	},
	workflow: {
		transition: {
			title: 'Nächster Schritt',
			failed: 'Schritt nicht möglich',
		},
		confirm: {
			title: 'Schritt bestätigen',
			text: 'Soll der Vorgang wirklich auf "{step}" gesetzt werden?',
		},
		history: {
			empty: 'Noch keine Schritte.',
			from: 'aus "{step}"',
			system: 'System',
			undone: 'zurückgenommen',
		},
	},
};
